<template>
  <customModal :containermd="true" @closeModal="closeModal">
    
    <!-- TITLE -->
    <template #title>
      Randomization
    </template>

    <!-- BODY -->
    <template #body>
      <div class="row">

        <!-- Checkbox -->
        <div class="col-12 mb-3">
          <label>
            Is the subject to be randomized?
          </label> &nbsp;
          <input type="checkbox" v-model="randomization.isRandomized" /> &nbsp;
            <small class="errorClass" v-if="formErrors.isRandomized">
            {{ formErrors.isRandomized }}
          </small>
        </div>

        <!-- Conditional Fields -->
        <div  class="row w-100">

          <!-- Randomization ID -->
          <div class="col-lg-4 mb-2">
            <label class="col-form-label">
              Randomization ID
              <sup v-if="randomization.isRandomized"><i class="fa fa-asterisk required"></i></sup>
            </label>
            <input
              type="text"
              class="form-control"
              v-model="randomization.randomizationId"
            />
            <small class="errorClass" v-if="formErrors.randomizationId">
              {{ formErrors.randomizationId }}
            </small>
          </div>

          <!-- Kit Number (Optional unless backend supports) -->
          <div class="col-lg-4 mb-2">
            <label class="col-form-label">
              Kit Number
              <sup v-if="randomization.isRandomized"><i class="fa fa-asterisk required"></i></sup>
            </label>
            <input
              type="text"
              class="form-control"
              v-model="randomization.kitNumber"
            />
             <small class="errorClass" v-if="formErrors.kitNumber">
              {{ formErrors.kitNumber }}
            </small>
          </div>

          <!-- Randomization Date -->
          <div class="col-lg-4 mb-2">
            <label class="col-form-label">
              Randomization Date
              <sup v-if="randomization.isRandomized"><i class="fa fa-asterisk required"></i></sup>
            </label>
            <input
              type="date"
              class="form-control"
              v-model="randomization.randomizationDate"
            />
            <small class="errorClass" v-if="formErrors.randomizationDate">
              {{ formErrors.randomizationDate }}
            </small>
          </div>
          <div class="col-lg-4 mb-2">
            <label class="col-form-label">
              Status
            </label>  
            <select  class="form-control" v-model="randomization.status">
              <option value="" disabled>Select status</option>
              <option v-for="status in statusList" :key="status.id" :value="status.status">
                  {{ status.status }}
              </option>
            </select>
          </div>
          <div class="col-lg-4 mb-2">
            <label class="col-form-label">
              Milestone
            </label>  
            <select  class="form-control" v-model="randomization.milestone">
              <option value="" disabled>Select milestone</option>
              <option v-for="mile in milestoneList" :key="mile.id" :value="mile.milestoneName">
                {{ mile.milestoneName }}
              </option>
            </select>
          </div>

        </div>
      </div>

      <!-- ACTION -->
      <div class="text-end mt-3">
        <button class="save_btn px-4 py-1" @click="saveRandomization">
          Save
        </button>
      </div>

    </template>
  </customModal>
</template>
<script src="./RandomizationModal.js"></script>